import * as React from "react";
import type { SVGProps } from "react";
const SvgZoomIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.293 21.707a1 1 0 0 0 1.414-1.414zm-2.936-5.764a1 1 0 0 0-1.414 1.414zM12 8a1 1 0 1 0-2 0zm-2 6a1 1 0 1 0 2 0zm-2-4a1 1 0 1 0 0 2zm6 2a1 1 0 1 0 0-2zm4-1a7 7 0 0 1-7 7v2a9 9 0 0 0 9-9zm-7 7a7 7 0 0 1-7-7H2a9 9 0 0 0 9 9zm-7-7a7 7 0 0 1 7-7V2a9 9 0 0 0-9 9zm7-7a7 7 0 0 1 7 7h2a9 9 0 0 0-9-9zm10.707 16.293-4.35-4.35-1.414 1.414 4.35 4.35zM10 8v6h2V8zm-2 4h6v-2H8z"
    />
  </svg>
);
export default SvgZoomIn;
